import * as THREE from 'three';
import rwxMouseTrack from 'roseworx/js/common/rwxMouseTracking';
import rwxMatrix from 'roseworx/js/modules/rwxMatrix';
import rwxGeometry from 'roseworx/js/helpers/rwxGeometryHelpers';
import rwxMath from 'roseworx/js/helpers/rwxMathHelpers';
import rwxMisc from 'roseworx/js/helpers/rwxMiscHelpers';
import {rwxAnimationChain} from 'roseworx/js/modules/rwxAnimation';

const Font = {"glyphs":{"\"":{"ha":447,"x_min":60,"x_max":388,"o":"m 388 607 l 269 607 l 269 946 l 388 946 l 388 607 m 178 607 l 60 607 l 60 946 l 178 946 l 178 607 z "},"#":{"ha":1004,"x_min":71,"x_max":935,"o":"m 642 0 l 521 0 l 569 229 l 339 229 l 290 0 l 171 0 l 219 229 l 71 229 l 71 338 l 242 338 l 294 593 l 138 593 l 138 704 l 318 704 l 367 936 l 489 936 l 440 704 l 671 704 l 719 936 l 839 936 l 790 704 l 935 704 l 935 593 l 767 593 l 713 338 l 869 338 l 869 229 l 690 229 l 642 0 m 593 338 l 647 593 l 417 593 l 363 338 l 593 338 z "},"%":{"ha":1228,"x_min":67,"x_max":1161,"o":"m 422 -1 l 294 -1 l 800 940 l 929 940 l 422 -1 m 532 722 q 464 557 532 625 q 299 489 396 489 q 135 557 203 489 q 67 722 67 625 q 135 886 67 818 q 299 954 203 954 q 464 886 396 954 q 532 722 532 818 m 182 722 q 216 639 182 674 q 299 604 250 604 q 382 639 347 604 q 417 722 417 674 q 382 805 417 771 q 299 839 347 839 q 216 804 250 839 q 182 722 182 769 m 1161 222 q 1093 58 1161 125 q 929 -10 1025 -10 q 764 58 832 -10 q 696 222 696 125 q 764 387 696 318 q 929 456 832 456 q 1093 387 1025 456 q 1161 222 1161 318 m 846 306 q 828 288 846 306 q 811 222 811 271 q 846 139 811 174 q 929 104 881 104 q 1012 139 978 104 q 1046 222 1046 174 q 1012 306 1046 271 q 929 340 978 340 q 846 306 881 340 z "},"(":{"ha":442,"x_min":86,"x_max":460,"o":"m 460 -272 l 311 -272 q 86 363 86 10 q 301 982 86 710 l 449 982 q 287 680 342 843 q 232 356 232 517 q 290 35 232 200 q 460 -272 349 -131 z "},")":{"ha":442,"x_min":-18,"x_max":356,"o":"m 132 -272 l -18 -272 q 152 35 93 -131 q 211 356 211 201 q 156 678 211 515 q -6 982 100 842 l 142 982 q 356 363 356 711 q 132 -272 356 11 z "},"*":{"ha":607,"x_min":40,"x_max":567,"o":"m 500 500 l 411 435 l 332 543 q 304 599 315 567 q 276 543 299 574 l 196 435 l 106 500 l 186 608 q 232 653 206 635 l 224 653 q 168 661 193 653 l 40 704 l 74 810 l 203 768 q 260 736 238 756 q 247 801 247 768 l 247 936 l 358 936 l 358 801 q 347 739 358 765 q 404 769 372 758 l 532 810 l 567 704 l 439 663 q 383 654 414 654 l 376 654 q 422 610 401 639 l 500 500 z "},"+":{"ha":783,"x_min":74,"x_max":708,"o":"m 708 410 l 451 410 l 451 151 l 325 151 l 325 410 l 74 410 l 74 533 l 325 533 l 325 793 l 451 793 l 451 533 l 708 533 l 708 410 z "},",":{"ha":340,"x_min":-11,"x_max":290,"o":"m 108 -172 l -11 -172 l 122 153 l 290 153 l 108 -172 z "},"-":{"ha":486,"x_min":74,"x_max":413,"o":"m 413 313 l 74 313 l 74 429 l 413 429 l 413 313 z "},".":{"ha":268,"x_min":40,"x_max":228,"o":"m 201 149 q 214 136 201 149 q 228 83 228 122 q 201 17 228 44 q 135 -11 174 -11 q 67 17 94 -11 q 40 83 40 44 q 67 149 40 122 q 135 176 94 176 q 201 149 174 176 z "},"/":{"ha":585,"x_min":-10,"x_max":635,"o":"m 131 -142 l -10 -142 l 494 982 l 635 982 l 131 -142 z "},";":{"ha":340,"x_min":-11,"x_max":290,"o":"m 108 -172 l -11 -172 l 122 153 l 290 153 l 108 -172 m 258 608 q 271 594 258 608 q 285 542 285 581 q 258 476 285 503 q 190 450 231 450 q 125 476 151 450 q 99 542 99 503 q 125 609 99 582 q 190 636 151 636 q 258 608 231 636 z "},"<":{"ha":757,"x_min":74,"x_max":690,"o":"m 690 289 l 690 150 l 74 407 l 74 539 l 690 796 l 690 657 l 215 474 l 690 289 z "},"=":{"ha":783,"x_min":74,"x_max":708,"o":"m 708 560 l 74 560 l 74 676 l 708 676 l 708 560 m 708 268 l 74 268 l 74 386 l 708 386 l 708 268 z "},">":{"ha":757,"x_min":67,"x_max":682,"o":"m 682 407 l 67 150 l 67 289 l 542 474 l 67 657 l 67 796 l 682 539 l 682 407 z "},"?":{"ha":631,"x_min":71,"x_max":581,"o":"m 319 297 l 190 297 l 189 521 q 440 683 440 521 q 399 788 440 749 q 276 828 357 828 q 71 761 174 828 l 71 896 q 289 947 161 947 q 501 880 421 947 q 581 693 581 813 q 500 510 581 575 q 321 438 419 444 l 319 297 m 321 151 q 335 138 321 151 q 349 83 349 124 q 321 16 349 43 q 253 -11 293 -11 q 185 16 213 -11 q 158 83 158 43 q 186 151 158 124 q 253 179 214 179 q 321 151 293 179 z "},"[":{"ha":451,"x_min":101,"x_max":443,"o":"m 443 -258 l 101 -258 l 101 982 l 443 982 l 443 861 l 235 861 l 235 -137 l 443 -137 l 443 -258 z "},"]":{"ha":451,"x_min":10,"x_max":350,"o":"m 350 -258 l 10 -258 l 10 -137 l 218 -137 l 218 861 l 10 861 l 10 982 l 350 982 l 350 -258 z "},"{":{"ha":483,"x_min":64,"x_max":460,"o":"m 460 -257 q 386 -269 422 -269 q 250 -208 306 -269 q 194 -50 194 -147 q 207 47 194 -15 q 219 138 219 108 q 189 241 219 197 q 99 293 158 285 q 64 294 86 294 l 64 428 q 99 429 83 428 q 188 479 156 435 q 219 583 219 524 q 207 674 219 613 q 194 771 194 736 q 250 929 194 868 q 386 990 306 990 q 460 978 422 990 l 460 847 q 414 860 436 860 q 353 833 375 860 q 332 765 332 807 q 344 667 332 733 q 357 563 357 601 q 312 428 357 483 q 190 361 267 372 q 312 294 267 350 q 357 158 357 238 q 344 53 357 119 q 332 -43 332 -12 q 353 -112 332 -85 q 414 -139 375 -139 q 460 -126 436 -139 l 460 -257 z "},"|":{"ha":338,"x_min":106,"x_max":232,"o":"m 232 -269 l 106 -269 l 106 965 l 232 965 l 232 -269 z "},"}":{"ha":483,"x_min":24,"x_max":419,"o":"m 288 -50 q 233 -209 288 -149 q 96 -269 178 -269 q 24 -257 61 -269 l 24 -126 q 68 -139 44 -139 q 129 -112 107 -139 q 151 -43 151 -85 q 139 53 151 -12 q 126 158 126 119 q 171 294 126 238 q 292 361 215 350 q 171 428 215 372 q 126 563 126 483 q 139 667 126 601 q 151 765 151 733 q 129 833 151 806 q 68 860 107 860 q 24 847 44 860 l 24 978 q 96 990 61 990 q 233 930 178 990 q 288 771 288 869 q 275 674 288 736 q 263 583 263 613 q 294 479 263 524 q 385 429 326 435 q 419 428 399 428 l 419 294 q 385 293 396 294 q 293 241 324 285 q 263 138 263 197 q 275 47 263 108 q 288 -50 288 -15 z "}},"familyName":"Hind Vadodara Medium","ascender":1563,"descender":-518,"underlinePosition":-174,"underlineThickness":69,"boundingBox":{"yMin":-515,"xMin":-610,"yMax":1475,"xMax":3183},"resolution":1000,"original_font_information":{"format":0,"copyright":"Copyright (c) 2015 Indian Type Foundry (info@indiantypefoundry.com)","fontFamily":"Hind Vadodara Medium","fontSubfamily":"Regular","uniqueID":"1.001;ITFO;HindVadodara-Medium","fullName":"Hind Vadodara Medium","version":"Version 1.001;PS 1.0;hotconv 1.0.86;makeotf.lib2.5.63406; ttfautohint (v1.5.33-1714) -l 8 -r 50 -G 200 -x 13 -D latn -f gujr -w G -W -c -X \"\"","postScriptName":"HindVadodara-Medium","trademark":"Hind is a trademark of the Indian Type Foundry.","manufacturer":"Indian Type Foundry","designer":"Hitesh Malaviya","manufacturerURL":"https://github.com/itfoundry/hind-vadodara","licence":"This Font Software is licensed under the SIL Open Font License, Version 1.1. This license is available with a FAQ at: http://scripts.sil.org/OFL","licenceURL":"http://scripts.sil.org/OFL","preferredFamily":"Hind Vadodara","preferredSubfamily":"Medium"},"cssFontWeight":"normal","cssFontStyle":"normal"};

class Brackets extends rwxMatrix
{
	constructor()
	{
		super({parent: 'brackets', lights: true, fov:70, nv:1, fv:1200, THREEInstance: THREE});
		this.loaded = false;
		this.destroyDemo();
		this.camera.position.x = -3;
		this.directLight.position.set(10 , -20, 15);
		this.ambience.color = new this.THREE.Color("#1342a0");

		this.mouseTrack = new rwxMouseTrack(this.parent.parentNode);

		this.loadFont().then((res)=>{
			this.mainBrackets(res);
			this.backgroundCharacters(res);
			this.loaded=true;
			this.bracketAnimation();
		});
	}

	bracketAnimation(){
		const animations = [
			{
				from:[this.pos1.x,this.pos1.y,this.pos2.x,this.pos2.y], 
				to:[this.pos1.x+30,this.pos1.y+30,this.pos2.x-30,this.pos2.y-30], 
				easing:'easeInElastic', 
				duration:3000,
				delay:1000
			},
			{
				to:[this.pos1.x, this.pos1.y, this.pos2.x, this.pos2.y],
				easing:'easeInElastic', 
				duration:3000
			},
			{
				from: 0,
				to:1080,
				easing: 'easeOutBack',
				duration: 5000,
				delay:1000
			},
			{
				from:[this.pos1.x,this.pos1.y,this.pos2.x,this.pos2.y],
				control: [
					{cp1:this.pos1.x-100, cp2:this.pos1.x+100},
					{cp1:this.pos1.y-10, cp2:this.pos1.y+10},
					{cp1:this.pos2.x+100, cp2:this.pos2.x-100},
					{cp1:this.pos2.y-10, cp2:this.pos2.y+10},
				],
				to:[this.pos1.x,this.pos1.y,this.pos2.x,this.pos2.y],
				easing: 'easeInOutCubic',
				duration: 2000,
				delay:1000
			},
			{
				from:0,
				to:360,
				easing:'easeInQuint',
				duration:2000,
				delay:1000
			},
			{
				from:0,
				to:360,
				easing:'easeOutQuint',
				duration:2000,
			},
			{
				from: this.pos1.z,
				to: -600,
				easing: 'easeInQuint',
				duration: 1500,
				delay:1000
			},
			{
				from: -600,
				to: this.pos1.z,
				easing: 'easeOutQuint',
				duration:1500
			}
		];

		this.flickerAnimation = new rwxAnimationChain({
			sequence: [
				{
					from: 1,
					to: 0.33,
					control: {cp1:rwxMath.randomInt(0.33, 0.53), cp2:rwxMath.randomInt(0.23, 0.43)},
					easing: 'easeInOutElastic',
					duration: 3000,
				},
				{
					from: 0.33,
					to: 1,
					control: {cp1:rwxMath.randomInt(0.83, 0.63), cp2:rwxMath.randomInt(0.73, 0.93)},
					easing: 'easeInOutElastic',
					duration: 2000,
				}
			],
			loop: true
		})

		this.bracketAnimations = new rwxAnimationChain({
			sequence:animations,
			loop:true
		});
	}

	stop()
	{
		this.unhook();
		this.mouseTrack.remove();
	}

	mainBrackets(res)
	{
		let mainConf = this.getFontConfig(res);
		this.pos1 = window.innerWidth < 700 ? new this.THREE.Vector3(40, 80, -300) : new this.THREE.Vector3(70, 80, -230);
		this.pos2 = window.innerWidth < 700 ? new this.THREE.Vector3(-40, -80, -300) : new this.THREE.Vector3(-70, -80, -230);
		this.bracket1 = this.createBracket('}', this.pos1, mainConf);
		this.bracket2 = this.createBracket('{', this.pos2, mainConf);
	}

	backgroundCharacters(res)
	{
		this.toRotate = [];
		const z = -1000;
		let bg = ['#', '|', '[', ']', '?', '<', '>', '.', ',', '/', '-', '"', '=', '%', '(', ')', '...', '*', ';', '+'];
		rwxMisc.shuffleArray(bg);
		let multiplier = 1;
		if(window.innerWidth < 500){multiplier=0.5}
		if(window.innerWidth > 1200){
			multiplier=1.5;
			bg.push('[', ']', '(', ')');
		}
		const bgpos = [
			new this.THREE.Vector3(-450*multiplier, 600, z),
			new this.THREE.Vector3(-270*multiplier, 533, z),
			new this.THREE.Vector3(33*multiplier, 569, z),
			new this.THREE.Vector3(-146*multiplier, 312, z),
			new this.THREE.Vector3(450*multiplier, 548, z),
			new this.THREE.Vector3(600*multiplier, 292, z),
			new this.THREE.Vector3(700*multiplier, 498, z),
			new this.THREE.Vector3(715*multiplier, 111, z),
			new this.THREE.Vector3(500*multiplier, 23, z),
			new this.THREE.Vector3(750*multiplier, -40, z),
			new this.THREE.Vector3(-723*multiplier, 100, z),
			new this.THREE.Vector3(-597*multiplier, -130, z),
			new this.THREE.Vector3(-783*multiplier, -303, z),
			new this.THREE.Vector3(-699*multiplier, -600, z),
			new this.THREE.Vector3(-636*multiplier, -417, z),
			new this.THREE.Vector3(193*multiplier, -487, z),
			new this.THREE.Vector3(-402*multiplier, -584, z),
			new this.THREE.Vector3(-37*multiplier, -620, z),
			new this.THREE.Vector3(387*multiplier, -583, z),
			new this.THREE.Vector3(-433*multiplier, -30, z),
			new this.THREE.Vector3(-703*multiplier, 557, z),
			new this.THREE.Vector3(-743*multiplier, 289, z),
			new this.THREE.Vector3(700*multiplier, -300, z),
			new this.THREE.Vector3(657*multiplier, -567, z)
		];
		let otherConf = this.getFontConfig(res);
		bg.map((l, i)=>{
			const geo = new this.THREE.TextGeometry( l, otherConf);
			let s = this.addShape(geo, new this.THREE.MeshPhongMaterial({wireframe:true, flatShading:true, opacity:0.1, transparent:true}));
			let position = bgpos[i];
			s.position.z = position.z;
			s.position.x = position.x;
			s.position.y = position.y;
			let obj = {
				mesh:s,
				directions:[],
				positions: {x:position.x, y:position.y, z: position.z},
				drag:  Math.random() /  233,
				theta: Math.floor(Math.random() * (20-2+1) + 2),
				lastMouse: this.mouseTrack.lastmouse,
				speed: (rwxMath.randomInt(1,2) / 100)
			}
			let dirs = ['x', 'y'];
			rwxMisc.shuffleArray(dirs);
			let no = rwxMath.randomInt(1,2);
			for(let i=0;i<no;i++)
			{
				obj.directions.push(dirs[i]);
			}
			this.toRotate.push(obj);
			return false;
		});
	}

	loadFont()
	{
		const loader = new this.THREE.FontLoader();
		return new Promise((resolve, reject)=>{
			resolve(loader.parse(Font));
		})	
	}

	getFontConfig(font)
	{
		return {
			font,
			size: 70,
			height: 5,
			curveSegments: 12,
			bevelEnabled: true,
			bevelThickness: 5,
			bevelSize: 3,
			bevelOffset: 0,
			bevelSegments: 10			
		}
	}

	createBracket(text, pos, settings)
	{
		const geometry = new this.THREE.TextGeometry( text, settings);
		let bracket = this.addShape(geometry, new this.THREE.MeshPhongMaterial({transparent: true}), false);
		bracket.position.set(-25, -25, -5);
    let pivot = new this.THREE.Group();
    pivot.position.set(pos.x, pos.y, pos.z);
    this.scene.add( pivot );
    pivot.add( bracket );	
    pivot.rotation.z = rwxGeometry.toRadians(45);
    return pivot;
	}

	animate()
	{
		if(this.loaded)
		{
			this.bracketAnimations.animate([
				(x, y, x2, y2)=>{
					this.bracket1.position.x = x;
					this.bracket1.position.y = y;
					this.bracket2.position.x = x2;
					this.bracket2.position.y = y2;
				},
				(x, y, x2, y2)=>{
					this.bracket1.position.x = x;
					this.bracket1.position.y = y;
					this.bracket2.position.x = x2;
					this.bracket2.position.y = y2;
				},
				(r)=>{
					this.bracket1.rotation.y = rwxGeometry.toRadians(r);
					this.bracket2.rotation.y = -rwxGeometry.toRadians(r);
				},
				(x, y, x2, y2)=>{
					this.bracket1.position.x = x;
					this.bracket1.position.y = y;
					this.bracket2.position.x = x2;
					this.bracket2.position.y = y2;
				},
				(r)=>{
					this.bracket1.rotation.x = -rwxGeometry.toRadians(r);
					this.bracket2.rotation.x = rwxGeometry.toRadians(r);
				},
				(r)=>{
					this.bracket1.rotation.x = rwxGeometry.toRadians(r);
					this.bracket2.rotation.x = -rwxGeometry.toRadians(r);
				},
				(z)=>{
					this.bracket1.position.z = z;
					this.bracket2.position.z = z;
				},
				(z)=>{
					this.bracket1.position.z = z;
					this.bracket2.position.z = z;
				},
			]);

			this.flickerAnimation.animate([
				(o)=>{
			    this.bracket1.children[0].material.opacity = o;
			    this.bracket2.children[0].material.opacity = o;				
				},
				(o)=>{
			    this.bracket1.children[0].material.opacity = o;
			    this.bracket2.children[0].material.opacity = o;				
				}
			]);

			this.toRotate.map((tr)=>{
				tr.directions.map((trd)=>{
					tr.mesh.rotation[trd] += tr.speed;
					return false;
				})
  			let x = tr.positions.x + (tr.lastMouse.x/tr.theta);
		    let y = tr.positions.y + (tr.lastMouse.y/tr.theta);	
		    tr.mesh.position.x = x;
		    tr.mesh.position.y = y;
		    // tr.mesh.position.z = tr.positions.z + (Math.abs(x)/10)
		    tr.lastMouse.x += (this.mouseTrack.parallaxmouse.x - tr.lastMouse.x) * tr.drag;
		    tr.lastMouse.y += (this.mouseTrack.parallaxmouse.y - tr.lastMouse.y) * tr.drag;
		    return false;
			});
		}
	}
}

export default Brackets;